import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
  Table,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";
import OnlineGroupClass2025 from "../../assets/OnlineGroupClass2025.pdf";
import LinerLoader from "../../components/loader/LinearProgress";

const EnrollonlineClass = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  const { onlineClass } = useSelector((state) => state.onlineClass);
  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );

  const filteredCourses = courseByEvents.sort(
    (a, b) => a.priority - b.priority
  );
  const defaultProps = {
    options: filteredCourses,
    getOptionLabel: (option) => option.name,
  };

  const options = [
    { label: "1", id: 1 },
    { label: "2", id: 2 },
    { label: "3", id: 3 },
  ];
  const data = {
    id: "33",
  };
  useEffect(() => {
    dispatch(actions.courseByEventsGetData(data));
    dispatch(actions.onlineClassGetData());
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      course_id: values.course_id,
      student_no: values.student_no,
      subscription_id: values.subscription_id,
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      choose_lang: values.choose_lang,
      gender: values.gender,
      age: values.age,
      address: values.address,
      city: values.city,
      pincode: values.pincode,
      preferred_month: values.preferred_month,
      preferred_day: values.preferred_day,
      preferred_time: values.preferred_time,
      totalfees: values.totalfees,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
      month: values.month,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for Online Group Classes.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  course_id: "",
                  student_no: "",
                  subscription_id: "",
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  gender: "",
                  choose_lang: "",
                  age: "",
                  address: "",
                  city: "",
                  pincode: "",
                  preferred_month: "",
                  preferred_day: "",
                  preferred_time: "",
                  totalfees: "",
                  is_enquiry: "0",
                  is_online_payment: "1",
                  month: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                  student_no: Yup.string().required("required"),
                  subscription_id: Yup.string().required("required"),
                  month: Yup.string().required("required"),
                })}
              >
                {(formProps) => {
                  const levelProps = {
                    options: onlineClass
                      .sort(
                        (a, b) =>
                          parseFloat(a.classes_per_week) -
                          parseFloat(b.classes_per_week)
                      )
                      ?.filter(
                        (i) =>
                          formProps.values.course_id == i.course_id &&
                          formProps.values.student_no == i.number_of_students
                      ),
                    getOptionLabel: (option) => option.classes_per_week ?? "",
                  };
                  console.log("formProps.values", formProps.values);
                  return (
                    <Form className="mt-3">
                      {isLoading ? (
                        <div className="p-3">
                          <LinerLoader />
                        </div>
                      ) : (
                        <Row className="form-group">
                          <Col md={12} className="mt-3">
                            <Label htmlFor="course_id" className="label">
                              Your Course:
                            </Label>
                            <InputGroup>
                              <Autocomplete
                                {...defaultProps}
                                id="course_id"
                                name="course_id"
                                getOptionSelected={(option, value) =>
                                  option.id === value.id
                                }
                                onChange={(event, newValue) => {
                                  formProps.setFieldValue(
                                    `course_id`,
                                    newValue?.id ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `totalfees`,
                                    newValue?.total_amount ?? ""
                                  );
                                  formProps.setFieldValue(
                                    `subscription_id`,
                                    ""
                                  );
                                  formProps.setFieldValue(`student_no`, "");
                                }}
                                sx={{ width: "100%" }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="-- Select Your Course First --"
                                    variant="outlined"
                                    name="course_id"
                                    size="small"
                                    className="form-control"
                                    error={
                                      formProps.touched.course_id &&
                                      Boolean(formProps.errors.course_id)
                                    }
                                    helperText={
                                      formProps.touched.course_id &&
                                      formProps.errors.course_id
                                    }
                                  />
                                )}
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      )}

                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="student_no" className="label">
                            No. of Students:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              options={options}
                              id="student_no"
                              name="student_no"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, newValue) => {
                                formProps.setFieldValue(
                                  `student_no`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(`subscription_id`, "");
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="-- Select -- *"
                                  variant="outlined"
                                  name="student_no"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.student_no &&
                                    Boolean(formProps.errors.student_no)
                                  }
                                  helperText={
                                    formProps.touched.student_no &&
                                    formProps.errors.student_no
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="subscription_id" className="label">
                            Number Of Class Per Week:
                          </Label>
                          <InputGroup>
                            <Autocomplete
                              {...levelProps}
                              id="subscription_id"
                              name="subscription_id"
                              getOptionSelected={(option, value) =>
                                option.id === value.id
                              }
                              onChange={(event, newValue) => {
                                formProps.setFieldValue(
                                  `subscription_id`,
                                  newValue?.id ?? ""
                                );
                                formProps.setFieldValue(
                                  `monthly_fee`,
                                  newValue?.fees_per_student_month ?? ""
                                );
                                formProps.setFieldValue(
                                  `classes_per_week`,
                                  newValue?.classes_per_week ?? ""
                                );
                                formProps.setFieldValue(
                                  `duration_of_each_class`,
                                  newValue?.duration_of_each_class ?? ""
                                );
                                formProps.setFieldValue(
                                  `classes_per_month`,
                                  newValue?.classes_per_month ?? ""
                                );
                                formProps.setFieldValue(
                                  `addmission_charges`,
                                  newValue?.addmission_charges ?? ""
                                );
                                formProps.setFieldValue(
                                  `activity_fee`,
                                  newValue?.activity_fee ?? ""
                                );
                                formProps.setFieldValue(
                                  `sub_total`,
                                  newValue?.sub_total ?? ""
                                );

                                formProps.setFieldValue(
                                  `totalfees`,
                                  newValue?.grand_total ?? ""
                                );
                                // week_days_id
                                formProps.setFieldValue(
                                  `week_days_id`,
                                  newValue?.week_days_id ?? ""
                                );
                              }}
                              sx={{ width: "100%" }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="-- Select -- *"
                                  variant="outlined"
                                  name="subscription_id"
                                  size="small"
                                  className="form-control"
                                  error={
                                    formProps.touched.subscription_id &&
                                    Boolean(formProps.errors.subscription_id)
                                  }
                                  helperText={
                                    formProps.touched.subscription_id &&
                                    formProps.errors.subscription_id
                                  }
                                />
                              )}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      {formProps.values.course_id == "308" ? (
                        <Row className="mt-3">
                          <Col md={12} className="mt-3">
                            <Label htmlFor="choose_lang" className="label">
                              Choose Your Book Language :
                            </Label>
                            <InputGroup>
                              <Field
                                component={CustomSelect}
                                type="select"
                                name="choose_lang"
                                id="choose_lang"
                                className={
                                  "form-control" +
                                  (formProps.errors.choose_lang &&
                                  formProps.touched.choose_lang
                                    ? " is-invalid"
                                    : "")
                                }
                              >
                                <option value="">-- Select --</option>
                                <option value={"English"}>English</option>
                                <option value={"Hindi"}>Hindi</option>
                              </Field>
                              <ErrorMessage
                                name="choose_lang"
                                component="div"
                                className="invalid-feedback"
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}
                      {/* FEE STRUCTURE: */}
                      {formProps.values.course_id !== "" &&
                      formProps.values.student_no !== "" &&
                      formProps.values.subscription_id !== "" ? (
                        <Row className="mt-3">
                          <Col md={10}>
                            <Label className="mt-3 mb-3 text-orange">
                              FEE STRUCTURE:
                            </Label>
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Fees Type</th>
                                  <th>Amount [In INR]</th>
                                </tr>
                              </thead>
                              <tbody className="text-center">
                                <tr>
                                  <th scope="row" rowSpan={2}>
                                    Monthly Fee:
                                  </th>
                                  <td>
                                    Select Months:
                                    <select>
                                      <option>1</option>
                                    </select>
                                  </td>
                                </tr>
                                <tr>
                                  <th scope="row">
                                    {formProps.values.monthly_fee} [{" "}
                                    {formProps.values.monthly_fee} per month]
                                  </th>
                                </tr>
                                <tr>
                                  <td>Number Of Class Per Week:</td>
                                  <td>{formProps.values.classes_per_week}</td>
                                </tr>
                                <tr>
                                  <td>Duration Of Each Class:</td>
                                  <td>
                                    {formProps.values.duration_of_each_class}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Number Of Class Per Month:</td>
                                  <td>{formProps.values.classes_per_month}</td>
                                </tr>
                                <tr>
                                  <td>
                                    Fees Per Student Per Month (To Be Paid In
                                    Advance):
                                  </td>
                                  <td>{formProps.values.monthly_fee}</td>
                                </tr>
                                <tr>
                                  <td>Sub Total:</td>
                                  <td>{formProps.values.sub_total}</td>
                                </tr>
                                <tr>
                                  <th scope="row">Grand Total:</th>
                                  <th scope="row">
                                    INR{" "}
                                    <input
                                      value={formProps.values.totalfees}
                                      readOnly
                                    />
                                  </th>
                                </tr>
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      ) : (
                        ""
                      )}

                      <p className="p-2">
                        <b>Note:</b> First Active Group Member will be
                        responsible for Entire Group Member's online fee
                        submission in case of Group.
                      </p>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientname" className="label">
                            Your Name:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientname"
                              id="clientname"
                              placeholder="Enter Your Name"
                              className={
                                "form-control" +
                                (formProps.errors.clientname &&
                                formProps.touched.clientname
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientname"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientemail" className="label">
                            Your Email:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientemail"
                              id="clientemail"
                              placeholder="Enter Your Email"
                              className={
                                "form-control" +
                                (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientemail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="clientphone" className="label">
                            Your Mobile:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="clientphone"
                              id="clientphone"
                              placeholder="Enter Your Mobile Number"
                              className={
                                "form-control" +
                                (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="clientphone"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="gender" className="label">
                            Your Gender:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="gender"
                              id="gender"
                              className={
                                "form-control" +
                                (formProps.errors.gender &&
                                formProps.touched.gender
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Gender</option>
                              <option value={"Male"}>Male</option>
                              <option value={"Female"}>Female</option>
                            </Field>
                            <ErrorMessage
                              name="gender"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="age" className="label">
                            Your Age:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="age"
                              id="age"
                              placeholder="Enter Your Age"
                              className={
                                "form-control" +
                                (formProps.errors.age && formProps.touched.age
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="age"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="city" className="label">
                            Your City:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="city"
                              id="city"
                              placeholder="Enter Your City"
                              className={
                                "form-control" +
                                (formProps.errors.city && formProps.touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="city"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={12} className="mt-3">
                          <Label htmlFor="address" className="label">
                            Your Address [Flat no. + Building] :
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="textarea"
                              name="address"
                              id="address"
                              placeholder="Enter Your Address"
                              className={
                                "form-control" +
                                (formProps.errors.address &&
                                formProps.touched.address
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="address"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="gender" className="label">
                            Your Pincode:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="text"
                              name="pincode"
                              id="pincode"
                              placeholder="Enter Your pincode"
                              className={
                                "form-control" +
                                (formProps.errors.pincode &&
                                formProps.touched.pincode
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="pincode"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="preferred_month" className="label">
                            Your Month for the classes:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="preferred_month"
                              id="preferred_month"
                              className={
                                "form-control" +
                                (formProps.errors.preferred_month &&
                                formProps.touched.preferred_month
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>-- Select --</option>
                              <option value="January">January</option>
                              <option value="February">February</option>
                              <option value="March">March</option>
                              <option value="April">April</option>
                              <option value="May">May</option>
                              <option value="June">June</option>
                              <option value="July">July</option>
                              <option value="August">August</option>
                              <option value="September">September</option>
                              <option value="October">October</option>
                              <option value="November">November</option>
                              <option value="December">December</option>
                            </Field>
                            <ErrorMessage
                              name="preferred_month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>

                      <Row className="form-group">
                        <Col md={6} className="mt-3">
                          <Label htmlFor="preferred_day" className="label">
                            Your Preferred Day:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="preferred_day"
                              id="preferred_day"
                              placeholder="Preferred Day"
                              className={
                                "form-control" +
                                (formProps.errors.preferred_day &&
                                formProps.touched.preferred_day
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option selected value="Monday">
                                Monday
                              </option>
                              <option value="Tuesday">Tuesday</option>
                              <option value="Wednesday">Wednesday</option>
                              <option value="Thursday">Thursday</option>
                              <option value="Friday">Friday</option>
                              <option value="Saturday">Saturday</option>
                              <option value="Sunday">Sunday</option>
                            </Field>
                            <ErrorMessage
                              name="preferred_day"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                        <Col md={6} className="mt-3">
                          <Label htmlFor="preferred_time" className="label">
                            Your Preferred Time:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomInput}
                              type="time"
                              name="preferred_time"
                              id="preferred_time"
                              placeholder="Preferred Time"
                              className={
                                "form-control" +
                                (formProps.errors.preferred_time &&
                                formProps.touched.preferred_time
                                  ? " is-invalid"
                                  : "")
                              }
                            />
                            <ErrorMessage
                              name="preferred_time"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={12} className="mt-3">
                          <Label htmlFor="month" className="label">
                            Select Month:
                          </Label>
                          <InputGroup>
                            <Field
                              component={CustomSelect}
                              type="select"
                              name="month"
                              id="month"
                              className={
                                "form-control" +
                                (formProps.errors.month &&
                                formProps.touched.month
                                  ? " is-invalid"
                                  : "")
                              }
                            >
                              <option value={""}>Select Month</option>
                              <option value={"1"}>One Months</option>
                              <option value={"6"}>Six Months</option>
                              <option value={"12"}>One Year</option>
                            </Field>
                            <ErrorMessage
                              name="month"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="form-group mt-3">
                        <Col md={6}>
                          <InputGroup>
                            <Field type="checkbox" name="checked" value="One" />

                            <span className="radiobtn-test">
                              {" "}
                              &nbsp;
                              <a
                                href={OnlineGroupClass2025}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Please Accept Terms & Condition
                              </a>
                            </span>

                            <ErrorMessage
                              name="branch"
                              component="div"
                              className="invalid-feedback"
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                      <div className="mt-3 mb-3 row">
                        <div className="col-12">
                          <Button
                            type="submit"
                            className="register-btn"
                            size="md"
                            block
                          >
                            {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default EnrollonlineClass;
